import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7802e2f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "website-detail-view" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "ps-1 h6 text-white" }
const _hoisted_4 = {
  key: 0,
  type: "button",
  class: "btn-close btn-close-white",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "p-2 settings min-vh-100 text-center pt-10 w-100" }
const _hoisted_7 = {
  class: "mt-10 text-white",
  "data-bs-dismiss": "modal"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "d-flex py-2 settings" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  class: "text-dark",
  value: "text"
}, "Text", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  class: "text-dark",
  value: "text-only-changes",
  selected: ""
}, "Text (only changes)", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  class: "text-dark",
  value: "markdown"
}, "Markdown", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  class: "text-dark",
  value: "raw"
}, "Raw HTML", -1))
const _hoisted_16 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 0,
  class: "flex-1 justify-content-center d-flex ps-4"
}
const _hoisted_18 = { class: "mt-2" }
const _hoisted_19 = { class: "me-5 ms-5 text-gray-100 px-2 py-2.5 rounded text-nowrap bg-red-400" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white font-bold" }, "vs.", -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 1,
  class: "text-center text-white flex-1 justify-content-center mb-4"
}
const _hoisted_23 = {
  key: 1,
  class: "text-danger mt-5 pt-5 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_Diff = _resolveComponent("Diff")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.website.url), 1),
      (_ctx.$route.name != 'website')
        ? (_openBlock(), _createElementBlock("button", _hoisted_4, null, 512))
        : _createCommentVNode("", true),
      (_ctx.$route.name == 'website')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: { name: 'index' },
            type: "button",
            class: "btn-close btn-close-white position-absolute right-3 top-3"
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showPayWall)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _createTextVNode("You have reached the end of your 2 month trial."),
              _hoisted_8,
              _createTextVNode(" Now you have to upgrade your workspace to a paid plan (starts at 6$)."),
              _hoisted_9,
              _createVNode(_component_router_link, { to: { name: 'payment' } }, {
                default: _withCtx(() => [
                  _createTextVNode(" Upgrade Now ")
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.showPayWall)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("select", {
              class: "rounded py-2 text-white bg-gray-500 px-2 me-5 ms-3 absolute",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.displayType) = $event))
            }, _hoisted_16, 512), [
              [_vModelSelect, _ctx.displayType]
            ]),
            (_ctx.historyItems.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.format(_ctx.selectedPrevItem?.updatedAt)), 1),
                    _hoisted_20
                  ]),
                  (_ctx.historyItems.length)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        class: "rounded py-2.5 px-2 me-5 ms-5 bg-green-500",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.slimSelectedItemTimestamp) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyItems, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            class: "text-dark",
                            value: item.timestamp,
                            key: item.timestamp
                          }, _toDisplayString(_ctx.format(item.updatedAt)), 9, _hoisted_21))
                        }), 128))
                      ], 512)), [
                        [_vModelSelect, _ctx.slimSelectedItemTimestamp]
                      ])
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, " No history yet "))
          ]),
          (!_ctx.loaded && !_ctx.error)
            ? (_openBlock(), _createBlock(_component_loading_spinner, {
                key: 0,
                class: "mt-5 pt-5"
              }))
            : _createCommentVNode("", true),
          (!_ctx.loaded && _ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", null, [
            (_ctx.displayType != 'rendered' && _ctx.loaded)
              ? (_openBlock(), _createBlock(_component_Diff, {
                  key: 0,
                  mode: "split",
                  folding: _ctx.onylChanges,
                  theme: "dark",
                  language: "html",
                  prev: _ctx.prev,
                  current: _ctx.next,
                  class: "diff"
                }, null, 8, ["folding", "prev", "current"]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.loaded]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}